import { makeTracker } from 'usageTracking'

// Every Global Search event carries `surface: 'global_search'` (see makeTracker).
export const trackGlobalSearch = makeTracker('global_search')
